// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/search/v1/facet.proto" (package "c1.api.search.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * A FacetValue message contains count and value of the facet entry.
 *
 * @generated from protobuf message c1.api.search.v1.FacetValue
 */
export interface FacetValue {
    /**
     * The name of this facet.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * The icon for this facet.
     *
     * @generated from protobuf field: string icon_url = 2
     */
    iconUrl: string;
    /**
     * The value of this facet.
     *
     * @generated from protobuf field: string value = 3
     */
    value: string;
    /**
     * The count of the values in this facet.
     *
     * @generated from protobuf field: int64 count = 4
     */
    count: number;
}
/**
 * The FacetRange message.
 *
 * @generated from protobuf message c1.api.search.v1.FacetRange
 */
export interface FacetRange {
    /**
     * The display name of the range.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * The icon of the range.
     *
     * @generated from protobuf field: string icon_url = 2
     */
    iconUrl: string;
    /**
     * The starting value of the range.
     *
     * @generated from protobuf field: int64 from = 3
     */
    from: number;
    /**
     * The ending value of the range.
     *
     * @generated from protobuf field: int64 to = 4
     */
    to: number;
    /**
     * The count of items in the range.
     *
     * @generated from protobuf field: int64 count = 5
     */
    count: number;
}
/**
 * The FacetValueItem message.
 *
 * @generated from protobuf message c1.api.search.v1.FacetValueItem
 */
export interface FacetValueItem {
    /**
     * An array of facet values.
     *
     * @generated from protobuf field: repeated c1.api.search.v1.FacetValue values = 2
     */
    values: FacetValue[];
}
/**
 * The FacetRangeItem message.
 *
 * @generated from protobuf message c1.api.search.v1.FacetRangeItem
 */
export interface FacetRangeItem {
    /**
     * An array of facet ranges.
     *
     * @generated from protobuf field: repeated c1.api.search.v1.FacetRange ranges = 2
     */
    ranges: FacetRange[];
}
/**
 * The FacetCategory indicates a grouping of facets by type. For example, facets "OnePassword" and "Okta" would group under an "Apps" category.
 *
 * @generated from protobuf message c1.api.search.v1.FacetCategory
 */
export interface FacetCategory {
    /**
     * The display name of the category.
     *
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * An icon for the category.
     *
     * @generated from protobuf field: string icon_url = 2
     */
    iconUrl: string;
    /**
     * The param that is being set when checking a facet in this category.
     *
     * @generated from protobuf field: string param = 3
     */
    param: string;
    /**
     * @generated from protobuf oneof: item
     */
    item: {
        oneofKind: "value";
        /**
         * The value of a facet category.
         *
         * @generated from protobuf field: c1.api.search.v1.FacetValueItem value = 100
         */
        value: FacetValueItem;
    } | {
        oneofKind: "range";
        /**
         * Ranges of values in the facet.
         *
         * @generated from protobuf field: c1.api.search.v1.FacetRangeItem range = 101
         */
        range: FacetRangeItem;
    } | {
        oneofKind: undefined;
    };
}
/**
 * Indicates one value of a facet.
 *
 * @generated from protobuf message c1.api.search.v1.Facets
 */
export interface Facets {
    /**
     * The facet being referenced.
     *
     * @generated from protobuf field: repeated c1.api.search.v1.FacetCategory facets = 1
     */
    facets: FacetCategory[];
    /**
     * The count of items in this facet.
     *
     * @generated from protobuf field: int64 count = 2
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class FacetValue$Type extends MessageType<FacetValue> {
    constructor() {
        super("c1.api.search.v1.FacetValue", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<FacetValue>): FacetValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.iconUrl = "";
        message.value = "";
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<FacetValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FacetValue): FacetValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string icon_url */ 2:
                    message.iconUrl = reader.string();
                    break;
                case /* string value */ 3:
                    message.value = reader.string();
                    break;
                case /* int64 count */ 4:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FacetValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string icon_url = 2; */
        if (message.iconUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.iconUrl);
        /* string value = 3; */
        if (message.value !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.value);
        /* int64 count = 4; */
        if (message.count !== 0)
            writer.tag(4, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetValue
 */
export const FacetValue = new FacetValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacetRange$Type extends MessageType<FacetRange> {
    constructor() {
        super("c1.api.search.v1.FacetRange", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "from", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "to", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<FacetRange>): FacetRange {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.iconUrl = "";
        message.from = 0;
        message.to = 0;
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<FacetRange>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FacetRange): FacetRange {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string icon_url */ 2:
                    message.iconUrl = reader.string();
                    break;
                case /* int64 from */ 3:
                    message.from = reader.int64().toNumber();
                    break;
                case /* int64 to */ 4:
                    message.to = reader.int64().toNumber();
                    break;
                case /* int64 count */ 5:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FacetRange, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string icon_url = 2; */
        if (message.iconUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.iconUrl);
        /* int64 from = 3; */
        if (message.from !== 0)
            writer.tag(3, WireType.Varint).int64(message.from);
        /* int64 to = 4; */
        if (message.to !== 0)
            writer.tag(4, WireType.Varint).int64(message.to);
        /* int64 count = 5; */
        if (message.count !== 0)
            writer.tag(5, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetRange
 */
export const FacetRange = new FacetRange$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacetValueItem$Type extends MessageType<FacetValueItem> {
    constructor() {
        super("c1.api.search.v1.FacetValueItem", [
            { no: 2, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FacetValue }
        ]);
    }
    create(value?: PartialMessage<FacetValueItem>): FacetValueItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.values = [];
        if (value !== undefined)
            reflectionMergePartial<FacetValueItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FacetValueItem): FacetValueItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.search.v1.FacetValue values */ 2:
                    message.values.push(FacetValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FacetValueItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.search.v1.FacetValue values = 2; */
        for (let i = 0; i < message.values.length; i++)
            FacetValue.internalBinaryWrite(message.values[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetValueItem
 */
export const FacetValueItem = new FacetValueItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacetRangeItem$Type extends MessageType<FacetRangeItem> {
    constructor() {
        super("c1.api.search.v1.FacetRangeItem", [
            { no: 2, name: "ranges", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FacetRange }
        ]);
    }
    create(value?: PartialMessage<FacetRangeItem>): FacetRangeItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ranges = [];
        if (value !== undefined)
            reflectionMergePartial<FacetRangeItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FacetRangeItem): FacetRangeItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.search.v1.FacetRange ranges */ 2:
                    message.ranges.push(FacetRange.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FacetRangeItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.search.v1.FacetRange ranges = 2; */
        for (let i = 0; i < message.ranges.length; i++)
            FacetRange.internalBinaryWrite(message.ranges[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetRangeItem
 */
export const FacetRangeItem = new FacetRangeItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FacetCategory$Type extends MessageType<FacetCategory> {
    constructor() {
        super("c1.api.search.v1.FacetCategory", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "param", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "value", kind: "message", oneof: "item", T: () => FacetValueItem },
            { no: 101, name: "range", kind: "message", oneof: "item", T: () => FacetRangeItem }
        ]);
    }
    create(value?: PartialMessage<FacetCategory>): FacetCategory {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.iconUrl = "";
        message.param = "";
        message.item = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<FacetCategory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FacetCategory): FacetCategory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string icon_url */ 2:
                    message.iconUrl = reader.string();
                    break;
                case /* string param */ 3:
                    message.param = reader.string();
                    break;
                case /* c1.api.search.v1.FacetValueItem value */ 100:
                    message.item = {
                        oneofKind: "value",
                        value: FacetValueItem.internalBinaryRead(reader, reader.uint32(), options, (message.item as any).value)
                    };
                    break;
                case /* c1.api.search.v1.FacetRangeItem range */ 101:
                    message.item = {
                        oneofKind: "range",
                        range: FacetRangeItem.internalBinaryRead(reader, reader.uint32(), options, (message.item as any).range)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FacetCategory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string icon_url = 2; */
        if (message.iconUrl !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.iconUrl);
        /* string param = 3; */
        if (message.param !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.param);
        /* c1.api.search.v1.FacetValueItem value = 100; */
        if (message.item.oneofKind === "value")
            FacetValueItem.internalBinaryWrite(message.item.value, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.search.v1.FacetRangeItem range = 101; */
        if (message.item.oneofKind === "range")
            FacetRangeItem.internalBinaryWrite(message.item.range, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.FacetCategory
 */
export const FacetCategory = new FacetCategory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Facets$Type extends MessageType<Facets> {
    constructor() {
        super("c1.api.search.v1.Facets", [
            { no: 1, name: "facets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FacetCategory },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<Facets>): Facets {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.facets = [];
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<Facets>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Facets): Facets {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.search.v1.FacetCategory facets */ 1:
                    message.facets.push(FacetCategory.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int64 count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Facets, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.search.v1.FacetCategory facets = 1; */
        for (let i = 0; i < message.facets.length; i++)
            FacetCategory.internalBinaryWrite(message.facets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.search.v1.Facets
 */
export const Facets = new Facets$Type();
